// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ReturnPolicy } from './return-policy';
import { ReturnReasonType } from './return-reason-type';
import { ReturnReasonTypeEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ReturnReason extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Boolean */
  chargeRestockFee!: boolean;
  /** Boolean */
  creditAccountOwnedReturns!: boolean;
  /** String(200) */
  explanationInquiry?: string;
  /** Boolean */
  includePrepaidReturnLabel!: boolean;
  /** Boolean */
  isActive?: boolean;
  /** Boolean */
  isExplanationRequired!: boolean;
  /** String(60) */
  name!: string;
  /** Guid FK returnPolicy */
  returnPolicyId!: string;
  /** Enum FK returnReasonType */
  returnReasonTypeId!: ReturnReasonTypeEnum;
  /** Binary */
  rowVersion!: any;
  /** FK returnPolicyId */
  returnPolicy!: ReturnPolicy;
  /** FK returnReasonTypeId */
  returnReasonType!: ReturnReasonType;
}

